module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-icon-f70ad0a099f33f45b0ed1735580ff575.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/shopping-cart-indicator/img/bag-icon.svg
 ** module id = 399
 ** module chunks = 1 27 28 80 143
 **/